import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["for"]

import { i18n } from '@/i18n';
import { onMounted, ref, watch } from 'vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'RowCheckBox',
  props: {
    labelText: { default: '' },
    isChecked: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;
const isChecked = ref(false);
const id = ref('');
// イベント
onMounted(() => {
  isChecked.value = props.isChecked;
  id.value = generateUniqueId();
});

watch(
  () => props.isChecked,
  () => {
    isChecked.value = props.isChecked;
  }
);

//関数
const isShowLabel = (): boolean => {
  return !!props.labelText;
};

// forタグ用：inputタグのユニークなidを生成する
const generateUniqueId = (): string => {
  return Math.random().toString(36).slice(-8);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("input", {
      id: id.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChecked).value = $event)),
      type: "checkbox",
      class: "checkbox-content",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (emits('change-status', isChecked.value)))
    }, null, 40, _hoisted_1), [
      [_vModelCheckbox, isChecked.value]
    ]),
    (isShowLabel())
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: id.value
        }, _toDisplayString(props.labelText), 9, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})